export const fileList = [
  {
    id: 1,
    categorySlug: 'document',
    fileName: 'My Report.docx',
    fileType: 'DOCX File',
    fileSize: '7 MB',
    fileUrl: '#',
    isDeleted: true,
    isStarred: true,
    shared: [
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/4.jpg' },
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/1.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/1.jpg' },
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/2.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/2.jpg' },
    ]
  },
  {
    id: 2,
    categorySlug: 'audio',
    fileName: 'Backsound.mp3',
    fileType: 'MP3 File',
    fileSize: '5.6 MB',
    fileUrl: '#',
    isDeleted: true,
    isStarred: true,
    shared: [
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/4.jpg' },
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/5.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/5.jpg' },
    ] 
  },
  {
    id: 3,
    categorySlug: 'image',
    fileName: 'Artboard-1.png',
    fileType: 'PNG File',
    fileSize: '2.3 MB',
    fileUrl: '#',
    isDeleted: true,
    isStarred: true,
    shared: [
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/6.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/6.jpg' },
    ] 
  },
  {
    id: 4,
    categorySlug: 'video',
    fileName: 'Final Present.mp4',
    fileType: 'MP4 File',
    fileSize: '154 MB',
    fileUrl: '#',
    isDeleted: true,
    isStarred: true,
    shared: [
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/8.jpg' },
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/13.jpg' },
    ] 
  },
  {
    id: 5,
    categorySlug: 'folder',
    fileName: 'Work',
    fileType: 'Folder',
    fileSize: '8.9 GB',
    fileUrl: '#',
    isDeleted: true,
    isStarred: true,
    shared: [
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/10.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/10.jpg' },
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/11.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/11.jpg' },
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/12.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/12.jpg' },
    ] 
  },
  {
    id: 6,
    categorySlug: 'document',
    fileName: 'My Report.docx',
    fileType: 'DOCX File',
    fileSize: '15 MB',
    fileUrl: '#',
    isDeleted: true,
    isStarred: true,
    shared: [
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/13.jpg' },
    ] 
  },
  {
    id: 7,
    categorySlug: 'image',
    fileName: 'Avatar.png',
    fileType: 'PNG File',
    fileSize: '2 MB',
    fileUrl: '#',
    isDeleted: true,
    isStarred: true,
    shared: [
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/14.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/14.jpg' },
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/15.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/15.jpg' },
    ] 
  },
  {
    id: 8,
    categorySlug: 'video',
    fileName: 'Mountain.mp4',
    fileType: 'MP4 File',
    fileSize: '74 MB',
    fileUrl:  '#',
    isDeleted: true,
    isStarred: true,
    shared: [
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/16.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/16.jpg' },
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/17.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/17.jpg' },
    ] 
  },
  {
    id: 9,
    categorySlug: 'document',
    fileName: 'Finance.xlsx',
    fileType: 'XLSX File',
    fileSize: '8.9 MB',
    fileUrl: '#',
    isDeleted: true,
    isStarred: true,
    shared: [
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/18.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/18.jpg' },
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/19.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/19.jpg' },
    ] 
  },
  {
    id: 10,
    categorySlug: 'document',
    fileName: 'Template.docx',
    fileType: 'DOCX File',
    fileSize: '3 MB',
    fileUrl: '#',
    isDeleted: true,
    isStarred: true,
    shared: [
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/20.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/21.jpg' },
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/22.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/22.jpg' },
    ] 
  },
  {
    id: 11,
    categorySlug: 'video',
    fileName: 'Final Present.mp4',
    fileType: 'MP4 File',
    fileSize: '154 MB',
    fileUrl: '#',
    isDeleted: true,
    isStarred: true,
    shared: [
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/23.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/23.jpg' },
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/24.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/24.jpg' },
    ] 
  },
  {
    id: 12,
    categorySlug: 'video',
    fileName: 'MV Clip 4K.mp4',
    fileType: 'MP4 File',
    fileSize: '20 GB',
    fileUrl: '#',
    isDeleted: true,
    isStarred: true,
    shared: [
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/25.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/25.jpg' },
      { username: 'Fulano de Tal', avatar: 'https://randomuser.me/api/portraits/men/26.jpg' },
      { username: 'Ana de Tal', avatar: 'https://randomuser.me/api/portraits/women/26.jpg' },
    ] 
  }
]
